/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OrthodonticCoverage/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import OrthoCoverage from './OrthoCoverage/index'
import React from 'react'
import RemoveOrAddAction from './RemoveOrAddAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OrthodonticCoverage({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/OrthodonticCoverage"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="OrthodonticCoverage.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-bQGaM': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="OrthodonticCoverage.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Orthodontic Coverage"
/>
<RemoveOrAddAction
  viewPath={`${viewPath}/RemoveOrAddAction`}
/>
</div>
<OrthoCoverage
  viewPath={`${viewPath}/OrthoCoverage`}
/>
</div>
{children}
</React.Fragment>)
}